import { render, staticRenderFns } from "./ProductChips.vue?vue&type=template&id=22f72ba6"
import script from "./ProductChips.vue?vue&type=script&lang=js"
export * from "./ProductChips.vue?vue&type=script&lang=js"
import style0 from "./ProductChips.vue?vue&type=style&index=0&id=22f72ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports